// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import moment from 'moment';
import { CalendarEvents } from './Calendar';
import { User } from './User';

export const isDevEnvironment = process.env.NODE_ENV === 'development';

export const devTestUser: User = {
  name: 'Test User',
  email: 'test@microsoft.com',
  functionsAppToken: 'test-functions-app-token'
};

export const devTestCalendarEvents: CalendarEvents = [
  {
    startTime: moment().subtract(2, 'hour'),
    endTime: moment().subtract(1, 'hour'),
    title: 'Previous test meeting',
    description: 'A test meeting that has happened in the past',
    joinUrl: 'https://teams.microsoft.com/meet/273109502538?p=OLornNxIcxiqwKrekS'
  },
  {
    startTime: moment(),
    endTime: moment().add(1, 'hour'),
    title: 'Current test meeting',
    description: 'A test meeting that is currently happening',
    joinUrl: 'https://teams.microsoft.com/meet/233719273257?p=6hV8wRDm1PuiBz89VY'
  },
  {
    startTime: moment().add(1, 'hour'),
    endTime: moment().add(2, 'hour'),
    title: 'Future test meeting',
    description: 'A test meeting that is happening in the future',
    joinUrl: 'https://teams.microsoft.com/meet/257070259438?p=KMpnLEsmn9Ff3AdGHt'
  }
];
